import React from 'react';
import { getBackgroundColor, getBorderColor, getTextColorByBgColor } from '../../util/getColorClassName.tsx';
import { parseRedesignHeadingRTF } from '../../util/xhtmlParser.tsx';
import { motion } from 'motion/react';
import { SquaresArrow } from '../../components/SquaresArrow.tsx';
const HighlightsBlock = ({ props, className }) => {
    const getHighlightBlockContent = (item, isLink) => {
        return (React.createElement("div", { className: `flex items-center py-[20px] px-[20px] lg:px-[30px] h-full transition-all duration-200 border gap-y-[30px] ${item.backgroundColor
                ? getBorderColor(item.backgroundColor)
                : 'border-primary-portsmouthNavySuperdark'} rounded-lg ${item.backgroundColor
                ? getBackgroundColor(item.backgroundColor)
                : 'bg-primary-portsmouthNavySuperdark'} ${isLink
                ? 'hover:border-lakeBledBlueLight hover:shadow-highlightBlock-item'
                : ''}` },
            item.image && (React.createElement("div", { className: "w-[70px] h-[50px] lg:w-[100px] lg:h-[70px] flex items-center mr-3" },
                React.createElement("img", { src: item.image.url, className: "object-contain h-full" }))),
            React.createElement("div", { className: "flex-1" },
                item.title && (React.createElement("h3", { className: `text-[34px] lg:text-[40px] leading-[120%] font-medium mb-1 ${getTextColorByBgColor(item.backgroundColor)}` }, parseRedesignHeadingRTF(item.title, {
                    textColorClass: item.backgroundColor
                        ? getTextColorByBgColor(item.backgroundColor)
                        : 'text-primary-portsmouthNavySuperdark'
                }))),
                item.subtitle && (React.createElement("p", { className: `text-white text-sm ${getTextColorByBgColor(item.backgroundColor)}` }, parseRedesignHeadingRTF(item.subtitle, {
                    textColorClass: item.backgroundColor
                        ? getTextColorByBgColor(item.backgroundColor)
                        : 'text-primary-portsmouthNavySuperdark'
                })))),
            isLink && (React.createElement("div", { className: "w-[24px] h-[32px] ml-[20px] lg:ml-[30px] m-auto cursor-pointer self-end overflow-hidden" },
                React.createElement(SquaresArrow, { width: "24", height: "32", viewBox: "0 0 24 32", fill: "none", className: "w-full h-full" })))));
    };
    return (React.createElement("div", { className: `flex flex-col gap-y-5 lg:gap-y-2.5 ${className}` }, Object.values(props).map((item, index) => {
        if (!item || !item.title)
            return null;
        if (item.link.url) {
            return (React.createElement(motion.a, { key: index, href: item.link.url, target: item.link.target || '_self', "aria-label": item?.title || '', className: "block group", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 1 }, transition: { duration: 0.6, delay: index * 0.2 } }, getHighlightBlockContent(item, true)));
        }
        else {
            return (React.createElement(motion.div, { className: "block", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 1 }, transition: { duration: 0.6, delay: index * 0.2 } }, getHighlightBlockContent(item, false)));
        }
    })));
};
export default HighlightsBlock;
